import { Box, Button, chakra, Link, shouldForwardProp, Stack, Text } from '@chakra-ui/react'
import { isValidMotionProp, motion } from 'framer-motion'
import React from 'react'
import { ReplayIcon } from '../icons/ReplayIcon'
import { DeathQuizShareButtons } from './deathQuizShareButtons'
import { handleKarmaNavigation } from '../../../app/landing_pages/karma/Components/utils'
// import { quizFgColor } from './quizCardElement'
// const MotionButton = motion(Button)

const MotionButton = chakra(motion.button, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

export default function QuizResults({
  numCorrect,
  numQuestions,
  onRetake,
  showLinkToMainPage,
}) {
  let quizFgColor = '#b7870c'
  const didWell = numCorrect >= 4
  const shareText = `I scored ${numCorrect} out of ${numQuestions} on "Karma Book Quiz: Myth or Fact?" - I'm on the path to unraveling the mysteries of Karma! Take the Karma Book Quiz:`
  const url = handleKarmaNavigation('/#karma-myth-or-fact')
  const hashtags = 'SadhguruBookTour2025'

  return (
    <Stack
      spacing={3}
      alignItems='center'
      width={{ base: '100%', md: '375px' }}
      textAlign={'center'}
      // sx={{ maxWidth: '450px', mx: 'auto', textAlign: 'center' }}
      color={quizFgColor}
    >
      <Text
        // variant='h5'
        fontFamily={'JuanaAltRegular'}
        fontWeight={'500'}
        fontSize={'32px'}
      >
        You got {numCorrect} out of {numQuestions}!
      </Text>
      <Text
        fontWeight={400}
        fontSize={'20px'}
        fontFamily={'FedraSansStd-book'}
      >
        {didWell
          ? `Wow, you're on the path to unraveling Karma!`
          : `Uh-oh, looks like you've got some serious reading to do!`}
      </Text>
      <Text fontWeight={400} fontSize={'24px'} py={'10px'} fontFamily={'FedraSansStd-book'} >
      {
          <Link
            href='https://karma.sadhguru.org/karma/events'
            cursor={'pointer'}
            textDecoration={'underline'}
            color={quizFgColor}
            // component={'a'}
            // sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            textTransform={'unset'}
            display={'inline'}
            // onClick={(e) => {
            //   e.preventDefault()
            //   scrollToElement('#pre-order', {
            //     behavior: 'smooth',
            //     duration: 100
            //   })
            // }}
          >
            Get tickets
          </Link>
        }
        {' '} to the Karma Virtual Book Tour that includes a copy of Karma: A Yogi’s Guide to Crafting Your Destiny by Sadhguru      
      </Text>
      <Text fontFamily={'FedraSansStd-book'} fontSize={'24px'} fontWeight={400} variant='body1'>
        Share Karma Quiz: Myth or Fact? with a friend
      </Text>
      <DeathQuizShareButtons
        shareText={shareText}
        url={url}
        hashtags={hashtags}
      />
      <Button
        fontSize="16px"
        fontFamily="FedraSansStd-book"
        variant="outline"
        color={quizFgColor}
        borderColor={quizFgColor}
        borderRadius="50px"
        bg="transparent"
        leftIcon={<ReplayIcon color={quizFgColor}/>}
        _hover={{
          opacity: 0.96,
          bg: '#b7870c33',
        }}
        onClick={onRetake}
      >
        RETAKE
      </Button>


      {showLinkToMainPage && (
        <Link href='/book' underline='hover'>
          About The Book
        </Link>
      )}
    </Stack>
  )
}
